<template>
	<div class="accordion" role="tablist">
		<b-card  no-body class="mb-2">
			<b-card-header header-tag="header" class="p-1" role="tab">
				<div class="d-flex justify-content-between align-items-center mx-2">
					<h3>
						{{ service.serviceId }} <small v-if="serviceTag" class="text-muted">({{ serviceTag }})</small>
						<span
							v-if="isRunning"
							class="spinner-border spinner-border-sm mr-2"
							role="status"
							aria-hidden="true"
						></span>
					</h3>
		
					<b-button v-b-toggle="'accordion-service-' + service.serviceId">
							<i class="when-open fas fa-chevron-up"></i>
							<i class="when-closed fas fa-chevron-down"></i>
					</b-button>
				</div>
			</b-card-header>
			<b-collapse visible :id="'accordion-service-' + service.serviceId" :accordion="'accordion-service-' + service.serviceId" role="tabpanel">
				<b-card-body >
					<TestsTable :tests="sortedTests" :mode="mode" @previewResult="previewResult" @cancelTest="cancelTest"/>
				</b-card-body>
			</b-collapse>
		</b-card>
	</div>
	
</template>

<script>
import TestsTable from './TestsTable';
import { sortByFullPath } from '../../util/test-runner';

export default {
	name: 'TestService',
	props: ['service', 'mode'],
	components: {
		TestsTable
	},
	computed: {
		sortedTests() {
			return this.service && this.service.tests ? sortByFullPath(this.service.tests) : [];
		},
		isRunning() {
			return this.mode !== 'select' && this.sortedTests.some((test) => test.status === 'RUNNING' || test.status === 'PENDING');
		},
		serviceTag() {
			return this.sortedTests && this.sortedTests.length > 0 ? this.sortedTests[0].serviceTag : null;
		}
	},
	methods: {
		previewResult(result) {
			this.$emit('previewResult', result);
		},
		cancelTest(id) {
			this.$emit('cancelTest', id);
		}
	}
};
</script>

<style>

</style>
